export default __webpack_public_path__ + "static/media/pdf.82979a1b.svg";